import { request } from 'shared/lib/request';

export const getCreditorsRequest = ({ id, currentExercice, transition }) =>
  request.get(
    `/dashboards/${id}/creditors?exercice=${currentExercice}&transition=${transition}`
  );

export const getCreditorData = ({ dosId, ...data }) =>
  request.post(`dashboards/${dosId}/creditors/detailed`, data);
